import Shape from './index'

export default class Rect extends Shape {
  constructor(props) {
    super(props)
    this.draw()
  }

  _getRadius() {
    const { radius = {} } = this
    const r =
      typeof radius === 'number'
        ? { tl: radius, tr: radius, br: radius, bl: radius }
        : { tl: 1, tr: 1, br: 1, bl: 1 }
    for (const side in r) {
      r[side] = radius[side] || r[side]
    }
    return r
  }

  _drawBorder() {
    const { ctx, width, height, strokeStyle } = this

    if (this.stroke) {
      ctx.lineStyle(this.strokeWidth, this.stroke, this.strokeOpacity)
    }

    if (strokeStyle === 'dashed') {
      const radius = this.radius
      //horizontal dashed borders
      let step = (width - 2 * radius) / 9
      let i = radius
      while (i < width - radius) {
        const next = i + step
        ctx.moveTo(i, 0)
        ctx.lineTo(next, 0)
        ctx.moveTo(i, height)
        ctx.lineTo(next, height)
        i = next + step
      }
      //vertical dashed borders
      step = (height - 2 * radius) / 9
      i = radius
      while (i < height - radius) {
        const next = i + step
        ctx.moveTo(0, i)
        ctx.lineTo(0, next)
        ctx.moveTo(width, i)
        ctx.lineTo(width, next)
        i = next + step
      }
      //rounded corners
      const r = radius / 2
      ctx.moveTo(width - r, 0)
      ctx.quadraticCurveTo(width, 0, width, r)
      ctx.moveTo(width, height - r)
      ctx.quadraticCurveTo(width, height, width - r, height)
      ctx.moveTo(r, height)
      ctx.quadraticCurveTo(0, height, 0, height - r)
      ctx.moveTo(0, r)
      ctx.quadraticCurveTo(0, 0, r, 0)

      return
    }

    if (typeof this.radius === 'number') {
      ctx.drawRoundedRect(0, 0, width, height, this.radius)
    } else {
      const r = this._getRadius()
      ctx.moveTo(r.tl, 0)
      ctx.lineTo(width - r.tr, 0)
      ctx.quadraticCurveTo(width, 0, width, r.tr)
      ctx.lineTo(width, height - r.br)
      ctx.quadraticCurveTo(width, height, width - r.br, height)
      ctx.lineTo(r.bl, height)
      ctx.quadraticCurveTo(0, height, 0, height - r.bl)
      ctx.lineTo(0, r.tl)
      ctx.quadraticCurveTo(0, 0, r.tl, 0)
    }
  }

  draw() {
    const { ctx } = this
    ctx.scale.set(1)

    this.background && ctx.beginFill(this.background, this.alpha)
    this._drawBorder()
    ctx.endFill()
  }
}
